import React from "react"
import LayoutModal from "../../organisms/layoutModal/layout-modal"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS } from "@contentful/rich-text-types";
import Img from "gatsby-image"
import { useStaticQuery, graphql } from "gatsby"
import "./modal-retails.scss"
import useLocaleMode from "../../../hooks/useLocaleMode";
import useMobileMode from '../../../hooks/useMobileMode';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ModalRetails = props => {
  const { paramRetails } = props;
  const { locale } = useLocaleMode();
  const { isMobile } = useMobileMode();
  const options = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (node, next) => <p className="f-retails-content-item-description" >{next}</p>
    }
  };

  const query = useStaticQuery(graphql`
    query RETAILS {
      allContentfulTenaHome{
        nodes {
          node_locale
          retailsDeCompra {
            titulo
            logoDeRetail {
              fluid(maxWidth: 700, quality: 90) {
                src
                srcSet
                base64
                aspectRatio
                sizes
              }
              description
            }
            ctaRetail
            descripcionRetail{
              json
            }
            redireccionRetail
          }
        }
      }
    }
  `);

  const retailByCountry = query.allContentfulTenaHome.nodes.filter(node => node.node_locale === locale)[0];
  const isSlider = !isMobile && ((paramRetails && paramRetails.length > 4) || (retailByCountry && retailByCountry.retailsDeCompra.length > 4))

  const NextArrow = (next) => {
    const { onClick } = next;
    return (
      <span
        className="f-slider-control-next"
        onClick={onClick}
      />
    );
  }

  const PrevArrow = (prev) => {
    const { onClick } = prev;
    return (
      <span
        className="f-slider-control-prev"
        onClick={onClick}
      />
    );
  }

  var settings = {
    arrows: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '0',
    focusOnSelect: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />
  };

  const listItems = paramRetails ?
    paramRetails.map(
      (retail, index) => {
        return (
          <div className="f-retails-content-item" key={index}>
            <Img className="f-retails-content-item-image" fluid={retail.logoDeRetail.fluid} alt={retail.logoDeRetail.description} />
            <a className="f-button f-button--outlined f-button-retail" target="_blank" rel="noreferrer noopener"
              // href={props.commercialPartners ? props.commercialPartners[index] : retail.redireccionRetail}>{retail.ctaRetail}</a>
              href={retail.redireccionRetail}>{retail.ctaRetail}</a>
            {documentToReactComponents(retail.descripcionRetail.json, options)}
          </div>
        )
      }
    )
    :
    retailByCountry && retailByCountry.retailsDeCompra.map(
      (retail, index) => {
        return (
          <div className="f-retails-content-item" key={index}>
            <Img className="f-retails-content-item-image" fluid={retail.logoDeRetail.fluid} alt={retail.logoDeRetail.description} />
            <a className="f-button f-button--outlined f-button-retail" target="_blank" rel="noreferrer noopener"
              // href={props.commercialPartners ? props.commercialPartners[index] : retail.redireccionRetail}>{retail.ctaRetail}</a>
              href={retail.redireccionRetail}>{retail.ctaRetail}</a>
            {documentToReactComponents(retail.descripcionRetail.json, options)}
          </div>
        )
      }
    )



  return (
    <LayoutModal>
      <div className="f-modal-retails">
        <span className="f-modal-retails-icon" onClick={props.hideAction}>
          X
                </span>
        <div className="f-modal-retails-head">COMPRA EN LÍNEA</div>
        <div className="f-modal-retails-body">
          {isSlider ?
            <Slider {...settings} className="f-retails-content">
            {listItems}
            </Slider>

            :
            <div className="f-retails-content">
              {/* {retailByCountry && retailByCountry.retailsDeCompra.map(
                            (retail, index) => {
                                const isCorrectRetail = props.commercialPartners && props.commercialPartners[index] && props.commercialPartners[index].match(retail.redireccionRetail.split("/", 3)[2]);
                                return (
                                    <div className="f-retails-content-item" key={index}>
                                        <Img className="f-retails-content-item-image" fluid={retail.logoDeRetail.fluid} alt={retail.logoDeRetail.description} />
                                        <a className="f-button f-button--outlined f-button-retail" target="_blank" rel="noreferrer noopener"
                                            href={props.commercialPartners && (isCorrectRetail && isCorrectRetail.length > 0) ? props.commercialPartners[index] : retail.redireccionRetail}>{retail.ctaRetail}</a>
                                        {documentToReactComponents(retail.descripcionRetail.json, options)}
                                    </div>
                                )
                            }
                        )} */}
              {listItems}
            </div>
          }
        </div>
        <div className="f-modal-retails-footer">
          <span className="f-modal-retails-footer-icon" onClick={props.hideAction}>
            X
          </span>
        </div>
      </div>
    </LayoutModal>
  )
};

export default ModalRetails
